// Feedback du notaire sur une réponse générée : vote pouce (user_review) et tracking silencieux
// d'une édition manuelle (reply_edit), voir outlook.ts (handleSubmitReplyFeedback/reportReplyEditIfNeeded).
import { getPraetoriaApiToken, PRAETORIA_API_BASE_URL } from "../config";
import { buildApiError, PraetoriaTimeoutError } from "./errors";

const USER_REVIEW_TIMEOUT_MS = 15000;

export type UserReviewEvaluation = "ok" | "ko";

export async function submitUserReview(
  graphToken: string,
  evaluation: UserReviewEvaluation,
  subject: string,
  commentaire?: string,
  module?: string | null,
  versionModule?: string | null
): Promise<void> {
  const token = getPraetoriaApiToken();
  if (!token) {
    throw new Error("Token API Praetoria manquant (PRAETORIA_API_TOKEN).");
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), USER_REVIEW_TIMEOUT_MS);

  let response: Response;
  try {
    response = await fetch(`${PRAETORIA_API_BASE_URL}/app/email/user_review`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        graph_access_token: graphToken,
        evaluation,
        subject,
        commentaire: commentaire || null,
        module: module || null,
        version_module: versionModule || null,
      }),
      signal: controller.signal,
    });
  } catch (error) {
    if (error instanceof Error && error.name === "AbortError") {
      throw new PraetoriaTimeoutError();
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }

  if (!response.ok) {
    throw await buildApiError(response);
  }
}

const REPLY_EDIT_TIMEOUT_MS = 15000;

export async function submitReplyEdit(
  graphToken: string,
  subject: string,
  reponseIa: string,
  reponseFinale: string,
  sessionId: string,
  module?: string | null,
  versionModule?: string | null
): Promise<void> {
  const token = getPraetoriaApiToken();
  if (!token) {
    throw new Error("Token API Praetoria manquant (PRAETORIA_API_TOKEN).");
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), REPLY_EDIT_TIMEOUT_MS);

  let response: Response;
  try {
    response = await fetch(`${PRAETORIA_API_BASE_URL}/app/email/reply_edit`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        graph_access_token: graphToken,
        subject,
        reponse_ia: reponseIa,
        reponse_finale: reponseFinale,
        session_id: sessionId,
        module: module || null,
        version_module: versionModule || null,
      }),
      signal: controller.signal,
    });
  } catch (error) {
    if (error instanceof Error && error.name === "AbortError") {
      throw new PraetoriaTimeoutError();
    }
    throw error;
  } finally {
    clearTimeout(timeoutId);
  }

  if (!response.ok) {
    throw await buildApiError(response);
  }
}
